/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SignInContainer_auth = {
    readonly integrations: {
        readonly local: {
            readonly enabled: boolean;
            readonly targetFilter: {
                readonly stream: boolean;
            };
        };
        readonly facebook: {
            readonly enabled: boolean;
            readonly redirectURL: string;
            readonly targetFilter: {
                readonly stream: boolean;
            };
        };
        readonly google: {
            readonly enabled: boolean;
            readonly redirectURL: string;
            readonly targetFilter: {
                readonly stream: boolean;
            };
        };
        readonly oidc: {
            readonly enabled: boolean;
            readonly redirectURL: string | null;
            readonly targetFilter: {
                readonly stream: boolean;
            };
        };
    };
    readonly " $fragmentRefs": FragmentRefs<"SignInWithOIDCContainer_auth" | "SignInWithGoogleContainer_auth" | "SignInWithFacebookContainer_auth">;
    readonly " $refType": "SignInContainer_auth";
};
export type SignInContainer_auth$data = SignInContainer_auth;
export type SignInContainer_auth$key = {
    readonly " $data"?: SignInContainer_auth$data;
    readonly " $fragmentRefs": FragmentRefs<"SignInContainer_auth">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "enabled",
        "storageKey": null
    } as any), v1 = ({
        "alias": null,
        "args": null,
        "concreteType": "AuthenticationTargetFilter",
        "kind": "LinkedField",
        "name": "targetFilter",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "stream",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any), v2 = [
        (v0 /*: any*/),
        ({
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "redirectURL",
            "storageKey": null
        } as any),
        (v1 /*: any*/)
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "SignInContainer_auth",
        "selections": [
            {
                "alias": null,
                "args": null,
                "concreteType": "AuthIntegrations",
                "kind": "LinkedField",
                "name": "integrations",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "LocalAuthIntegration",
                        "kind": "LinkedField",
                        "name": "local",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            (v1 /*: any*/)
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacebookAuthIntegration",
                        "kind": "LinkedField",
                        "name": "facebook",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "GoogleAuthIntegration",
                        "kind": "LinkedField",
                        "name": "google",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "OIDCAuthIntegration",
                        "kind": "LinkedField",
                        "name": "oidc",
                        "plural": false,
                        "selections": (v2 /*: any*/),
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SignInWithOIDCContainer_auth"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SignInWithGoogleContainer_auth"
            },
            {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SignInWithFacebookContainer_auth"
            }
        ],
        "type": "Auth",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '7a251ab8548c560934c05614a62e3b25';
export default node;
